import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.app.buttons.cancel_cashout,
    (button) => {
        return {
            button
        }
    }
)